// import React, { Component, Suspense, lazy, createRef } from "react";
// import InfoAlert from "./../../components/user/home/InfoAlert";
// import Banner from "./../../components/user/home/Banner";
// import Deals from "./../../components/user/home/Deals";
// import Footer from "./../../components/common/Footer";
// // import ServicesDisplay from "./service/ServicesDisplay";
// import { GetAllBanner } from "../../components/common/BannerFrame";
// import SpinnerLoader from '../../components/common/SpinnerLoader';
// import { Helmet } from 'react-helmet';

// // Lazy load components
// const Header = lazy(() => import("./../../components/user/common/Header"));
// const PopularProducts = lazy(() => import("./../../components/user/home/PopularProducts"));
// const SuperRewardsSec = lazy(() => import("./../../components/user/home/SuperRewardsSec"));
// const TrendingProducts = lazy(() => import("./../../components/user/home/TrendingProducts"));
// const PopularBrands = lazy(() => import("./../../components/user/home/PopularBrands"));
// const RecentSearch = lazy(() => import("./../../components/user/home/RecentSearch"));
// const ServicesDisplay = lazy(() => import("./service/ServicesDisplay"));


// class Home extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isToggle: true,
//       serviceData: '',
//       isComponentVisible: {
//         popularProducts: false,
//         superRewardsSec: false,
//         trendingProducts: false,
//         popularBrands: false,
//         recentSearch: false,
//       },
//     };

//     // Create refs for each lazy-loaded component
//     this.componentRefs = {
//       popularProducts: createRef(),
//       superRewardsSec: createRef(),
//       trendingProducts: createRef(),
//       popularBrands: createRef(),
//       recentSearch: createRef(),
//     };
//   }

//   componentDidMount() {
//     const isToggleValue = JSON.parse(localStorage.getItem("isToggle"));
//     if (isToggleValue !== null) {
//       this.setState({ isToggle: isToggleValue });
//     }

//     // Set up IntersectionObservers for each component
//     this.setupObservers();
//   }

//   setupObservers = () => {
//     this.observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           const componentName = Object.keys(this.componentRefs).find(refName => this.componentRefs[refName].current === entry.target);
//           if (componentName) {
//             this.setState(prevState => ({
//               isComponentVisible: {
//                 ...prevState.isComponentVisible,
//                 [componentName]: true,
//               }
//             }));
//             this.observer.unobserve(entry.target); // Stop observing once loaded
//           }
//         }
//       });
//     });

//     // Observe each component ref
//     Object.values(this.componentRefs).forEach(ref => {
//       if (ref.current) this.observer.observe(ref.current);
//     });
//   };

//   componentWillUnmount() {
//     if (this.observer) {
//       // Clean up observers
//       this.observer.disconnect();
//     }
//   }

//   componentDidUpdate(prevProps, prevState) {
//     const isToggleValue = JSON.parse(localStorage.getItem("isToggle"));
//     if (isToggleValue !== prevState.isToggle) {
//       this.setState({ isToggle: isToggleValue });
//     }
//   }

//   handleIsToggle = (isToggle) => {
//     console.log("Home page", isToggle)
//     this.setState({ isToggle });
//   };

//   handleServiceData = (data) => {
//     this.setState({ serviceData: data });
//   };

//   render() {
//     const { isToggle, serviceData, isComponentVisible } = this.state;

//     return (
//       <React.Fragment>
//         <Helmet><title>{"Home - Pay Earth"}</title></Helmet>
//         <InfoAlert />
//         <GetAllBanner />
//         <Suspense fallback={<SpinnerLoader />}>
//           <Header handleIsToggle={this.handleIsToggle} sendServiceData={this.handleServiceData} />
//         </Suspense>
//         {!isToggle ? (
//           <Suspense fallback={<SpinnerLoader />}>
//             <ServicesDisplay serviceData={serviceData} />
//           </Suspense>
//         ) : (
//           <React.Fragment>
//             <Banner />
//             <Deals />
//             {/* PopularProducts Section */}
//             {/* <div ref={this.componentRefs.popularProducts}>
//               {isComponentVisible.popularProducts ? (
//                 <Suspense fallback={<SpinnerLoader />}>
//                   <PopularProducts />
//                 </Suspense>
//               ) : ("")}
//             </div> */}

//             <Suspense fallback={<SpinnerLoader />}>
//               <PopularProducts />
//             </Suspense>

//             {/* SuperRewardsSec Section */}
//             {/* <div ref={this.componentRefs.superRewardsSec}>
//               {isComponentVisible.superRewardsSec ? (
//                 <Suspense fallback={<SpinnerLoader />}>
//                   <SuperRewardsSec />
//                 </Suspense>
//               ) : ("")}
//             </div> */}

//             <Suspense fallback={<SpinnerLoader />}>
//               <SuperRewardsSec />
//             </Suspense>

//             {/* TrendingProducts Section */}
//             {/* <div ref={this.componentRefs.trendingProducts}>
//               {isComponentVisible.trendingProducts ? (
//                 <Suspense fallback={<SpinnerLoader />}>
//                   <TrendingProducts />
//                 </Suspense>
//               ) : ("")}
//             </div> */}

//             <Suspense fallback={<SpinnerLoader />}>
//               <TrendingProducts />
//             </Suspense>

//             {/* PopularBrands Section */}
//             {/* <div ref={this.componentRefs.popularBrands}>
//               {isComponentVisible.popularBrands ? (
//                 <Suspense fallback={<SpinnerLoader />}>
//                   <PopularBrands />
//                 </Suspense>
//               ) : ("")}
//             </div> */}

//             <Suspense fallback={<SpinnerLoader />}>
//               <PopularBrands />
//             </Suspense>

//             {/* RecentSearch Section */}
//             {/* <div ref={this.componentRefs.recentSearch}>
//               {isComponentVisible.recentSearch ? (
//                 <Suspense fallback={<SpinnerLoader />}>
//                   <RecentSearch />
//                 </Suspense>
//               ) : ("")}
//             </div> */}
//           </React.Fragment>
//         )}
//         <Footer />
//       </React.Fragment>
//     );
//   }
// }

// export default Home;


//************************TEST START**************************/

import React, { Component, Suspense, lazy, createRef } from "react";
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { Helmet } from 'react-helmet';
import InfoAlert from "./../../components/user/home/InfoAlert";
import Header from "./../../components/user/common/Header";
import { GetAllBanner } from "../../components/common/BannerFrame";
import BannerDisplay from "../../components/common/BannerDisplay";
import LegalNoticesBanner from "../../components/common/LegalNoticesBanner";
import HeaderBannerDisplay from "../../components/common/HeaderBannerDisplay";
import { Link } from 'react-router-dom';
import axios from 'axios';
import SectionTitle from '../../components/user/home/SectionTitle';
import HowPayEarthWorks from '../../components/user/home/HowPayEarthWorks';
import HomeCtaBanners from '../../components/user/home/HomeCtaBanners';

// Lazy load components
const PopularProducts = lazy(() => import("./../../components/user/home/PopularProducts"));
const SuperRewardsSec = lazy(() => import("./../../components/user/home/SuperRewardsSec"));
const TrendingProducts = lazy(() => import("./../../components/user/home/TrendingProducts"));
const PopularBrands = lazy(() => import("./../../components/user/home/PopularBrands"));
const Banner = lazy(() => import("./../../components/user/home/Banner"));
const Deals = lazy(() => import("./../../components/user/home/Deals"));
const Footer = lazy(() => import("./../../components/common/Footer"));
const ServicesDisplay = lazy(() => import("./service/ServicesDisplay"));

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
      serviceData: '',
      // Product states
      userProductData: [],
      currentProductData: [],
      currentProductPage: 1,
      productLoading: true,
      isComponentVisible: {
        popularProducts: false,
        superRewardsSec: false,
        trendingProducts: false,
        popularBrands: false,
        recentSearch: false,
      },
    };

    this.productsPerPage = 8; // Show 8 products per page

    // Create refs for each lazy-loaded component
    this.componentRefs = {
      popularProducts: createRef(),
      superRewardsSec: createRef(),
      trendingProducts: createRef(),
      popularBrands: createRef(),
      recentSearch: createRef(),
    };
  }

  componentDidMount() {
    const storedToggle = localStorage.getItem("isToggle");
    if (storedToggle !== null) {
      try {
        const isToggleValue = JSON.parse(storedToggle);
        if (typeof isToggleValue === "boolean") {
          this.setState({ isToggle: isToggleValue });
        }
      } catch (e) {
        /* ignore invalid isToggle in localStorage */
      }
    }

    // Fetch products data
    this.fetchProductData();

    // Set up IntersectionObservers for each component
    this.setupObservers();
  }

  // Fetch products data
  fetchProductData = async () => {
    try {
      const res = await axios.get("front/get-common-product");
      this.setState({ 
        userProductData: res.data.data,
        productLoading: false 
      }, () => {
        this.updateCurrentProductData();
      });
    } catch (error) {
      console.error("Error fetching product data: ", error);
      this.setState({ productLoading: false });
    }
  };

  // Update current page data when userProductData or currentProductPage changes
  updateCurrentProductData = () => {
    const { userProductData, currentProductPage } = this.state;
    const startIndex = (currentProductPage - 1) * this.productsPerPage;
    const endIndex = startIndex + this.productsPerPage;
    this.setState({
      currentProductData: userProductData.slice(startIndex, endIndex)
    });
  };

  // Product pagination handlers
  handleProductPageChange = (pageNumber) => {
    this.setState({ currentProductPage: pageNumber }, () => {
      this.updateCurrentProductData();
    });
  };

  prevProductPage = () => {
    const { currentProductPage } = this.state;
    if (currentProductPage > 1) {
      this.setState({ currentProductPage: currentProductPage - 1 }, () => {
        this.updateCurrentProductData();
      });
    }
  };

  nextProductPage = () => {
    const { currentProductPage, userProductData } = this.state;
    if (currentProductPage < Math.ceil(userProductData.length / this.productsPerPage)) {
      this.setState({ currentProductPage: currentProductPage + 1 }, () => {
        this.updateCurrentProductData();
      });
    }
  };

  // Utility functions for products
  formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  };

  truncateText = (text, maxLength = 100) => {
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + '...';
  };

  setupObservers = () => {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const componentName = Object.keys(this.componentRefs).find(refName => this.componentRefs[refName].current === entry.target);
          if (componentName) {
            this.setState(prevState => ({
              isComponentVisible: {
                ...prevState.isComponentVisible,
                [componentName]: true,
              }
            }));
            this.observer.unobserve(entry.target); // Stop observing once loaded
          }
        }
      });
    });

    // Observe each component ref
    Object.values(this.componentRefs).forEach(ref => {
      if (ref.current) this.observer.observe(ref.current);
    });
  };

  componentWillUnmount() {
    if (this.observer) {
      // Clean up observers
      this.observer.disconnect();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const storedToggle = localStorage.getItem("isToggle");
    if (storedToggle === null) {
      return;
    }
    try {
      const isToggleValue = JSON.parse(storedToggle);
      if (typeof isToggleValue === "boolean" && isToggleValue !== this.state.isToggle) {
        this.setState({ isToggle: isToggleValue });
      }
    } catch (e) {
      /* ignore invalid isToggle in localStorage */
    }
  }

  handleIsToggle = (isToggle) => {
    console.log("Home page", isToggle)
    this.setState({ isToggle });
  };

  handleServiceData = (data) => {
    this.setState({ serviceData: data });
  };

  // Render products section
  renderProductsSection = () => {
    const { currentProductData, userProductData, currentProductPage, productLoading } = this.state;

    if (productLoading) {
      return (
        <section className="popular_products_sec">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 m-auto text-center">
                <p>Loading products...</p>
              </div>
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="popular_products_sec">
        <div className="container">
          <div className="row">
            {currentProductData.length > 0 ? (
              currentProductData.map((product) => (
                <div key={product._id} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                  <Link className="card h-100" to={`/product-detail/${product._id}`}>
                    <div className="productListing-Image" style={{ height: '200px'}}>
                      <img
                        src={product.featuredImage || "/placeholder.svg"}
                        alt={product.name}
                        className="img-fluid"
                        style={{ maxHeight: '100%', width: 'auto', display: 'block', margin: '0 auto' }}
                      />
                      {product.badge && <span className="product-badge">{product.badge}</span>}
                    </div>
                    <div className="productListing-content text-center mt-2">
                      <div className="product-category">{product.category?.categoryName}</div>
                      <h3 className="m-auto">{product.name}</h3>
                      {product.brand && <div className="product-brand">{product.brand.brandName}</div>}
                      <div className="text-center mt-2">
                        <button type="button" className="btn custom_btn btn_yellow_bordered">
                          View More
                        </button>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-12">
                <p className="text-center fw-bold">No products available</p>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  };

  render() {
    const { isToggle, serviceData, isComponentVisible } = this.state;

    return (
      <React.Fragment>
        <Helmet><title>{"Home - Pay Earth"}</title></Helmet>
        
        {/* <InfoAlert /> */}
    
        <HeaderBannerDisplay
          location="homepage"
          section="hero"
          userType="all"
          height="150px"
        />
        <LegalNoticesBanner 
          location="header" 
          audience="all" 
          position="top"
          className="homepage-notices"
        />
        <GetAllBanner />
        
        <Header handleIsToggle={this.handleIsToggle} sendServiceData={this.handleServiceData} />

        {/* CTA banners — shown on both services and products views */}
        <HomeCtaBanners />

        <Suspense fallback={<SpinnerLoader />}>
          {isToggle === false ? (
            <ServicesDisplay serviceData={serviceData} />
          ) : (
            <React.Fragment>
              {/* Main Banner */}
              <BannerDisplay 
                location="homepage" 
                section="middle" 
                userType="all"
                layout="slider"
                width="100%"
                height="400px"
                imageFit="contain"
              />

              {/* Deals Section */}
              <Deals />

              {/* Original Popular Products */}
              {/* <PopularProducts /> */}

              {/* NEW: Integrated Products Section */}
              {this.renderProductsSection()}

              {/* Featured Banner */}
              <BannerDisplay
                location="homepage"
                section="featured"
                userType="all"
                layout="slider"
                width="100%"
                height="400px"
                imageFit="contain"  
              />

              {/* Trending Products */}
              <TrendingProducts />

              {/* Popular Brands */}
              <PopularBrands />
            </React.Fragment>
          )}
          <HowPayEarthWorks />
          <Footer />
        </Suspense>

        {/* Add the CSS styles */}
   <style jsx>{`
          .popular_products_sec {
            padding: 60px 0;
            background-color: #f8f9fa;
          }

          .cards_wrapper {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 15px;
            margin-top: 40px;
            margin-bottom: 40px;
          }

          .cards_wrapper .card {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            text-decoration: none;
            color: inherit;
            display: block;
            position: relative;
          }

          .cards_wrapper .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
            text-decoration: none;
            color: inherit;
          }

          .productListing-Image {
            position: relative;
            width: 100%;
            height: 220px;
            overflow: hidden;
          }

          .productListing-Image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }

          .cards_wrapper .card:hover .productListing-Image img {
            transform: scale(1.05);
          }

          .product-badge {
            position: absolute;
            top: 10px;
            left: 10px;
            background: #28a745;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 600;
            text-transform: uppercase;
          }

          .productListing-content {
            padding: 15px;
          }

          .product-category {
            font-size: 0.75rem;
            color: #6c757d;
            text-transform: uppercase;
            font-weight: 500;
            margin-bottom: 8px;
          }

          .productListing-content h3 {
            font-size: 1.1rem;
            font-weight: 600;
            color: #333;
            margin-bottom: 8px;
            line-height: 1.3;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .product-brand {
            font-size: 0.85rem;
            color: #007bff;
            font-weight: 500;
            margin-bottom: 8px;
          }

          .product-desc {
            font-size: 0.9rem;
            color: #666;
            line-height: 1.4;
            margin-bottom: 15px;
          }

          .product-price {
            margin-bottom: 10px;
          }

          .product-price .price {
            font-size: 1.2rem;
            font-weight: 700;
            color: #2c5aa0;
          }

          .product-price .vat {
            font-size: 0.75rem;
            color: #6c757d;
            margin-left: 5px;
          }

          .product-rating {
            margin-bottom: 15px;
            font-size: 0.85rem;
          }

          .product-rating .rating {
            color: #ffc107;
            font-weight: 600;
          }

          .product-rating .review-count {
            color: #6c757d;
            margin-left: 5px;
          }

          .custom_btn.btn_yellow {
            background-color: #ffc107;
            border-color: #ffc107;
            color: #212529;
            font-weight: 600;
            padding: 8px 20px;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          .custom_btn.btn_yellow:hover {
            background-color: #e0a800;
            border-color: #e0a800;
            transform: translateY(-1px);
          }

          .cart-pagination {
            margin-top: 40px;
            display: flex;
            justify-content: center;
          }

          .pagination-wrapper {
            display: flex;
            list-style: none;
            padding: 0;
            margin: 0;
            gap: 5px;
          }

          .pagination-wrapper li button {
            padding: 8px 12px;
            border: 1px solid #dee2e6;
            background: white;
            color: #495057;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 500;
          }

          .pagination-wrapper li button:hover:not(:disabled) {
            background-color: #e9ecef;
            border-color: #adb5bd;
          }

          .pagination-wrapper li button.active {
            background-color: #007bff;
            border-color: #007bff;
            color: white;
          }

          .pagination-wrapper li button:disabled {
            background-color: #f8f9fa;
            border-color: #dee2e6;
            color: #6c757d;
            cursor: not-allowed;
          }

          @media (max-width: 768px) {
            .cards_wrapper {
              grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
              gap: 10px;
            }
            
            .popular_products_sec {
              padding: 40px 0;
            }
            
            .productListing-Image {
              height: 200px;
            }
            
            .productListing-content {
              padding: 15px;
            }
          }

          @media (max-width: 576px) {
            .cards_wrapper {
              grid-template-columns: 1fr;
              gap: 8px;
            }
            
            .pagination-wrapper {
              flex-wrap: wrap;
              justify-content: center;
            }
            
            .pagination-wrapper li button {
              padding: 6px 10px;
              font-size: 0.9rem;
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default Home;




//***********************TEST END****************************//


